import React from "react";
import { useState, useEffect } from "react";
import GlobalFunctions from "../../services/GlobalFunctions";
import PasarelaService from "../../services/PasarelaService";
import PromoServices from "../../services/PromoServices";
import Swal from "sweetalert2";

const BotonPagos = (params) => {
  const promoServices = new PromoServices();
  const [valorPagar, setValorPagar] = useState(0);
  const [valorPagarOtro, setValorPagarOtro] = useState(0);
  const [radioCuotasSelected, setRadioCuotasSelected] = useState(true);
  const glob = new GlobalFunctions();
  const pasarelaService = new PasarelaService();
  const [datos, setDatos] = useState([]);

  useEffect(() => {
    // document.getElementById('radio_valor_cuota').checked = true
    promoServices.getDatos().then((data) => {
      setDatos(data);
    });
  }, []);

  useEffect(() => {
    if (params.valor_cuotas !== valorPagar) {
      validarSiSaldoMayorQCuota();
    }
  });

  function validarSiSaldoMayorQCuota() {
    const saldo = parseInt(params.saldoTotal);
    const cuota = parseInt(params.valor_cuotas);
    if (saldo < cuota) {
      setValorPagar(params.saldoTotal);
    } else {
      setValorPagar(params.valor_cuotas);
    }
  }

  function calcular_pagar_con_cuota() {
    setRadioCuotasSelected(true);
    validarSiSaldoMayorQCuota();
  }

  function calcular_pagar_otro_valor() {
    setRadioCuotasSelected(false);
  }

  function establecerValorPagar() {
    let valor = 0;
    if (radioCuotasSelected) {
      valor = valorPagar;
    } else {
      if (valorPagarOtro > 2000) {
        valor = valorPagarOtro;
      } else {
        alert("El valor a pagar debe ser mayor a 2000");
        window.location.reload();
        return;
      }
    }
    return valor;
  }

  function loadingOn() {
    document.getElementById("btnPagarLoading").style.display = "inline";
    document.getElementById("botonPagar").style.display = "none";
  }

  function loadingOff() {
    document.getElementById("btnPagarLoading").style.display = "none";
    document.getElementById("botonPagar").style.display = "inline";
  }

  function iniciarPagoWompi() {
    let valorPagar = establecerValorPagar();
    if (isNaN(valorPagar)) {
      alert("El valor a pagar debe ser mayor a 0!");
    } else {
      valorPagar = Math.trunc(valorPagar);
      const obj = {
        valor: valorPagar + "00",
        producto: params.fuente + ". Wompi",
        fecha_credito: params.fecha_prest,
      };
      document.getElementById("amount").value = valorPagar + "00";
      loadingOn();
      pasarelaService.getRefPago(obj).then((data) => {
        loadingOff();
        document.getElementById("ref").value = data[0].id;
        document.getElementById("integrity").value = data[0].comentarios;
        document.getElementById("nCredito").value = params.fecha_prest;
        document.getElementById("form_wompi").submit();
      });
    }
  }

  function cambioValorPagar(e) {
    const valor = parseInt(e.target.value);
    const saldo = parseInt(params.saldoTotal);
    if (saldo < valor) {
      setValorPagarOtro(saldo);
    } else {
      setValorPagarOtro(e.target.value);
    }
  }

  function abrirDialogoValor(botonPago) {
    document.getElementById("btnDialogoWompi").click();
  }

  function goWhats(tel) {
    let href = "https://api.whatsapp.com/send?phone=057" + tel + "&text=";
    window.open(
      href,
      "nuevo",
      "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, tittlebar=no, width=800, height=600"
    );
  }

  const copiarNumeroPortaPapeles = async (texto) => {
    try {
      await navigator.clipboard.writeText(texto);
      Swal.fire({
        title: texto + " copiado. Ahora pegalo en tu aplicación de pagos.",
        icon: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
    } catch (err) {}
  };

  return (
    <div>
      <div style={{ marginBottom: "0.5em", marginTop: "-0.5em" }}>
        <div className="col-4" style={{ cursor: "pointer" }}>
          <div
            onClick={() => abrirDialogoValor("wompi")}
            style={{ textAlign: "center" }}
          >
            <button id="btnPagar" className="btn btn-success">
              Pagar
            </button>
          </div>
        </div>
        <div
          className="col-4"
          style={{ cursor: "pointer", display: "none" }}
        ></div>
      </div>
      <button
        id="btnDialogoWompi"
        data-toggle="modal"
        data-target="#dialogo1"
        style={{ display: "none" }}
      ></button>
      <div className="modal fade" id="dialogo1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => document.getElementById("btnPagar").click()}
              ></button>
            </div>
            <div className="modal-body">
              <h5 style={{ textAlign: "left" }}>
                Realizar tus pagos por llaves o por nequi:
              </h5>
              <div className="container">
                <div className="align-items-center">
                  {datos.length > 0 &&
                    datos[0].listaImagenes.reverse().map((item, index) => {
                      return (
                        <span style={{ margin: "2px" }} key={index}>
                          <a className="cursorPointer">
                            <img
                              onClick={() => goWhats(item)}
                              style={{ width: "15%", height: "auto", marginRight: '0.4em' }}
                              src={
                                process.env.REACT_APP_URL_CASA +
                                "/Imagenes_config/whatsapp1.png"
                              }
                            />
                            <span
                              onClick={() => copiarNumeroPortaPapeles(item)}
                              style={{ fontSize: "1.2em", color: "black" }}
                            >
                                 {item}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                className="bi bi-copy"
                                viewBox="0 0 16 16"
                                style={{marginLeft: '0.4em'}}
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                                />
                              </svg>
                             
                            </span>
                          </a>
                          <br />
                          <br />
                        </span>
                      );
                    })}
                  {/*
                                        <div onClick={calcular_pagar_con_cuota} style={{ cursor: 'pointer', textAlign: 'center', padding: '0.4em' }} className="col-12 col-lg-6 col-md-12 col-sm-12 border border-primary rounded">
                                            <form id="form_wompi" action="https://checkout.wompi.co/p/" method="GET">
                                                <input type="hidden" name="public-key" value="pub_prod_mm5Qq0EJtZhzNzjV4Vm6fLQx6aHhCbjS" />
                                                <input type="hidden" name="currency" value="COP" />
                                                <input type="hidden" id="amount" name="amount-in-cents" value="0" />
                                                <input type="hidden" id="ref" name="reference" value="RE1" />
                                                <input type="hidden" id='integrity' name="signature:integrity" value="" />
                                                <input type="hidden" id='redirect' name="redirect-url" value={params.url_redirect} />
                                                
                                                <input type="hidden" name="shipping-address:country" value="CO" />
                                                <input type="hidden" id='cliente' name="shipping-address:phone-number" value={glob.getCookie('cedula')} />
                                                <input type="hidden" id='nCredito' name="shipping-address:city" value={params.nCredito} />
                                                <input type="hidden" name="shipping-address:region" value='Santander' />

                                                <input onChange={calcular_pagar_con_cuota} type="radio" checked={radioCuotasSelected ? true : false} id="radio_valor_cuota" name="valor_pago" value="valor_cuota" />
                                                <strong style={{ marginLeft: '0.2em' }}>Pagar valor de la cuota:</strong>
                                                <br />
                                                <input className='rounded' style={{ width: '6em' }} type="text" readOnly id="input_valor_cuota" name="input_valor_cuota" value={glob.formatNumber(valorPagar)} />
                                                <br />
                                            </form>
                                        </div>
                                        <div onClick={calcular_pagar_otro_valor} style={{ cursor: 'pointer', textAlign: 'center', padding: '0.4em' }} className="col-12 col-lg-6 col-md-12 col-sm-12 border border-success rounded">
                                            <input type="radio" onChange={calcular_pagar_otro_valor} checked={radioCuotasSelected ? false : true} id="radio_otro_valor" name="valor_pago" value="Otro valor" />
                                            <strong style={{ marginLeft: '0.2em' }}>Pagar otro valor</strong>
                                            <br />
                                            <input className='rounded' onChange={cambioValorPagar} value={valorPagarOtro} placeholder='Ingresa el valor a pagar' style={{ width: '6em' }} type="number" name="input_otro_valor" />
                                            <br />
                                        </div>
                                        */}
                </div>
                <div style={{ marginTop: "-1.5em" }}>
                  <img
                    style={{ width: "50%", height: "auto" }}
                    src={
                      process.env.REACT_APP_URL_CASA +
                      "/Imagenes_config/bre-b.webp"
                    }
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BotonPagos;
